import React from 'react'
import { FieldsGrid } from '../../PaymentDetailModal/PaymentDetailModal.styles'
import { PaymentEvidenceFields } from './PaymentEvidenceFields'

interface PaymentSubmittedFieldsProps {
  primaryPaymentMethod?: string
}

export function PaymentSubmittedFields({
  primaryPaymentMethod,
}: PaymentSubmittedFieldsProps) {
  return (
    <div style={{ marginTop: '16px' }}>
      <FieldsGrid>
        <PaymentEvidenceFields primaryPaymentMethod={primaryPaymentMethod} />
      </FieldsGrid>
    </div>
  )
}
